/**
 * Services Data for Right Choice Health Care
 * Structured for bilingual support (EN/AR)
 */

export const servicesData = [
  {
    id: 'elderly-care',
    title: {
      en: 'Elderly Care',
      ar: 'رعاية كبار السن',
    },
    description: {
      en: 'Compassionate companionship and daily living assistance tailored for seniors to maintain dignity and comfort at home.',
      ar: 'رفقة حانية ومساعدة في الأنشطة اليومية مصممة خصيصاً لكبار السن للحفاظ على كرامتهم وراحتهم داخل المنزل.',
    },
    features: {
      en: [
        'Elderly companionship',
        'Mobility assistance',
        'Medication reminders',
        'Feeding & hydration support',
        'Hygiene & bathing assistance',
        'Bedridden patient care',
      ],
      ar: [
        'رفقة ومجالسة كبار السن',
        'المساعدة على الحركة والتنقل',
        'التذكير بمواعيد الأدوية',
        'دعم التغذية وشرب السوائل',
        'المساعدة في النظافة والاستحمام',
        'رعاية المرضى طريحي الفراش',
      ],
    },
    image: '/images/elderly-care.jpg',
    path: '/services/elderly-care',
  },
  {
    id: 'mother-baby-care',
    title: {
      en: 'Mother & Baby Care',
      ar: 'رعاية الأم والطفل',
    },
    description: {
      en: 'Specialized support for new mothers and newborns, ensuring a healthy start and professional recovery during the postpartum period.',
      ar: 'دعم متخصص للأمهات الجدد والمواليد الجدد، لضمان بداية صحية وتعافي مهني خلال فترة ما بعد الولادة.',
    },
    features: {
      en: [
        'Newborn bathing & hygiene',
        'Breastfeeding/feeding support',
        'Diaper changing & skin care',
        'Sleep routine establishment',
        'Postpartum mother recovery',
        'Specialized twins baby care',
      ],
      ar: [
        'تحميم ونظافة حديثي الولادة',
        'دعم الرضاعة الطبيعية والتغذية',
        'تغيير الحفاضات والعناية بالبشرة',
        'تنظيم وبناء روتين النوم',
        'رعاية تعافي الأم بعد الولادة',
        'رعاية متخصصة للتوائم',
      ],
    },
    image: '/images/baby-care.jpg',
    path: '/services/mother-baby-care',
  },
  {
    id: 'home-nursing',
    title: {
      en: 'Home Nursing Care',
      ar: 'التمريض المنزلي',
    },
    description: {
      en: 'Professional medical assistance provided by licensed nurses in the safety and privacy of your own home.',
      ar: 'مساعدة طبية احترافية يقدمها ممرضون وممرضات مرخصون في أمان وخصوصية منزلك.',
    },
    features: {
      en: [
        'Professional nursing assessment',
        'Vital signs monitoring',
        'Wound dressing & care',
        'Injection administration',
        'Post-surgical recovery',
        'Trained medical assistance',
      ],
      ar: [
        'تقييم تمريضي مهني',
        'مراقبة العلامات الحيوية',
        'غيار الجروح والعناية بها',
        'إعطاء الحقن والأدوية',
        'التعافي ما بعد الجراحة',
        'مساعدة طبية متخصصة',
      ],
    },
    image: '/images/nursing.jpg',
    path: '/services/home-nursing',
  },
];
